import { getIllustrationColor } from '../../../constants/illustrationStageColors';

export function illustrationRenderer(param: { value: number | boolean }) {
  const { value } = param;
  const status = value === true ? 3 : value === false ? 0 : value;
  const color = getIllustrationColor(status);

  return `<span class='fa fa-image' style='color: ${color}'/>`;
}
